export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}classifier/classifier/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        delete: {
            method: 'DELETE',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Classifier/index.js